import { BackOutWorkOrderData, TimelinessWorkOrderData } from './types/reliabilityScore.type';

export const SHARED_CONSTANTS = {
  MAX_SCALE: 100,
  PROGRESS_BACKGROUND_BAR_COLOR: '#e5e5e5',
  MESSAGES: {
    WARNING: 'If you believe there is an error in your reported assignment cancellations, please',
    LINK_TEXT: 'let us know',
    LINK_URL: '/support-cases?openCreateModal=open&problemType=Dispute Check-in or Backout',
    NO_DATE: 'N/A',
  },
  DATE_FORMAT: {
    LOCALE: 'en-US' as const,
    OPTIONS: {
      month: '2-digit' as const,
      day: '2-digit' as const,
      year: 'numeric' as const,
    },
  },
  TABLE_HEADERS_COMMON: {
    DATE: 'Date',
    WORK_ORDER: 'Work Order',
    WORK_ORDER_TITLE_BASE: 'Work Order Title',
  },
} as const;

export const BACKOUT_CONSTANTS = {
  ...SHARED_CONSTANTS,
  BASE_WIDTH: 100,
  TABLE_HEADERS: {
    ...SHARED_CONSTANTS.TABLE_HEADERS_COMMON,
    TYPE: 'Type',
    WORK_ORDER_TITLE: 'Work Order Title',
  },
} as const;

export const TIMELINESS_CONSTANTS = {
  ...SHARED_CONSTANTS,
  BASE_WIDTH: 110,
  TABLE_HEADERS: {
    ...SHARED_CONSTANTS.TABLE_HEADERS_COMMON,
    TYPE: 'Schedule',
    WORK_ORDER_TITLE: 'Check in',
  },
  SCHEDULE_TYPE: {
    HOURS: 'Arrival Window',
  },
} as const;

export const ScheduleType = {
  EXACT: 'exact',
  RANGE: 'range',
  HOURS: 'hours',
} as const;

export const BACKOUT_TYPE_TO_CLASS_MAP: Record<BackOutWorkOrderData['type'], string> = {
  Early: 'type-early',
  Late: 'type-late',
  'No Call No Show': 'type-no-call',
};

export const TIMELINESS_TYPE_TO_CLASS_MAP: Record<TimelinessWorkOrderData['type'], string> = {
  early: 'type-early',
  late: 'type-late',
  on_time: 'type-on-time',
};

export const BACKOUT_TYPE_CONFIG = {
  FULFILLED: {
    label: 'Fulfilled',
    description: 'work orders assigned to and completed',
    color: 'green',
  },
  EARLY: {
    label: 'Early backouts',
    description: 'before the start of the confirmation window',
    color: 'yellow-light',
  },
  LATE: {
    label: 'Late backouts',
    description: 'after the start of the confirmation window',
    color: 'orange',
  },
  NO_CALL_NO_SHOW: {
    label: 'No Shows',
    title: 'Confirmation window',
    description: '6am - 12pm the day before the start time',
    color: 'red',
  },
} as const;

export const TIMELINESS_HARD_START_CONFIG = {
  HARD_START_SCHEDULES: {
    label: 'Hard Start Schedules',
    description: 'Your first check-in is between 30 minutes before and 15 minutes after the scheduled start time.',
    color: 'green',
  },
  ARRIVAL_WINDOW_SCHEDULES: {
    label: 'Arrival Window Schedules',
    description: 'Your first check-in is within the arrival window.',
    color: 'orange',
  },
} as const;

export const TIMELINESS_TYPE_CONFIG = {
  ON_TIME: {
    label: 'On time',
    color: 'green',
  },
  TOO_EARLY: {
    label: 'Too early',
    color: 'yellow-light',
  },
  LATE: {
    label: 'Late',
    color: 'orange',
  },
} as const;

export const CLOSE_BUTTON_CONFIG = {
  CLOSE: 'Close',
  COLOR: 'white',
  STYLES: {
    BACKGROUND_COLOR: 'white',
  },
} as const;

export const ON_TIME_CONSIDERATION = 'What is considered "on time?"';

export const TIME_FORMAT_CONSTANTS = {
  TIME_12_HOUR: 'hh:mm A',
  DATE_SEPARATOR: ' + ',
  UNIT_NAMES: {
    DAY: 'Day',
    DAYS: 'days',
  },
} as const;

export const BACKOUT_SCORE_NOTES = 'Early backouts are weighted less than late backouts, and no-shows have the worst impact';
export const TIMELINESS_SCORE_NOTES = 'Late check-ins are weighted more than too early check-ins';
